<div class="footer">
  <a href="" [routerLink]="['/chat']">Chat</a>
  <a href="" [routerLink]="['/rechtsinformation']" [queryParams]="{type: 'Impressum'}">Impressum</a>
  <a href="" [routerLink]="['/rechtsinformation']" [queryParams]="{type: 'Nutzungsbedingungen'}" >Nutzungsbedingungen</a>
  <a href="" [routerLink]="['/rechtsinformation']" [queryParams]="{type: 'Datenschutzerklaerung'}">Datenschutzerklärung</a>
</div>
